export default "__VITE_ASSET__DARDI$$u__"